import {Tab, TabsNavigation} from '@/components/atoms'
import {PageHeader} from '@/components/molecules'
import {DisplayContentTab, PageContent, UploadMedia} from '@/components/organisms'
// import { setSalesTargetDisplayContentMedia } from '@/store/slices/salesTargetSlice'
import {Constants} from '@/utils/constants/commonConstants'
// const ImageWithRadioBtn = ({imagesList, handleImageSelect}) => {
//   return (
//     <div className="flex justify-between">
//       {imagesList?.map((obj, idx) => {
//         return (
//           <div key={idx} className="w-23">
//             <input
//               name="radio-button"
//               value={obj?.src}
//               onClick={handleImageSelect}
//               type="radio"
//               className="radio-btn"
//             />
//             <img className="mt-2" src={obj?.src} />
//           </div>
//         )
//       })}
//     </div>
//   )
// }
const DisplayContent = ({
  displayContentFormData,
  setDisplayContentFormData,
  mediaCardFormData,
  setMediaCardFormData,
  MediaCardUiSchema,
  languages,
  handleTabClick,
  activeLanguage,
  targetType,
  errorMessage
  // joinCampaignFlag,
}) => {
  // const dispatch = useAppDispatch()
  // const handleImageSelect = e => {
  //   const mediaObj = {
  //     id: 'background-image',
  //     imageUri: '',
  //     imageBase64: '',
  //     imageUrl: e?.target?.value,
  //     cepRefId: 1,
  //     index: 0,
  //     optIn: 1,
  //     title: 'title bg image',
  //     excerpt: '',
  //     terms: '',
  //     language: 'en',
  //     filename: 'bg2.jpg',
  //   }

  //   dispatch(setSalesTargetDisplayContentMedia(mediaObj))
  // }
  // const getTargetImages = () => {
  //   let imgUrls = []
  //   if (targetType === 'Main Target') {
  //     imgUrls.push({
  //       src: 'https://admin.cep.mx.pepsico.com/Images/PromotionImages/2025/Abril/Objetivos/O_Mensual.jpg',
  //       id: 1,
  //     })
  //   } else {
  //     imgUrls.push(
  //       {
  //         src: 'https://admin.cep.mx.pepsico.com/Images/PromotionImages/2025/Abril/Objetivos/O_Salado.jpg',
  //         id: 1,
  //       },
  //       {
  //         src: 'https://admin.cep.mx.pepsico.com/Images/PromotionImages/2025/Abril/Objetivos/O_Gamesa.jpg',
  //         id: 2,
  //       },
  //       {
  //         src: 'https://admin.cep.mx.pepsico.com/Images/PromotionImages/2025/Abril/Objetivos/O_Paketaxo-Tostitos-Fritos.jpg',
  //         id: 3,
  //       },
  //       {
  //         src: 'https://admin.cep.mx.pepsico.com/Images/PromotionImages/2025/Abril/Objetivos/O_Sabritas-Doritos-Ruffles.jpg',
  //         id: 3,
  //       }
  //     )
  //   }

  //   return imgUrls
  // }
  return (
    <>
      <PageContent className="sales-target-component bg-neutral-800 text-white" pageContentWrapperClassName="relative">
        <div className="flex items-center justify-between">
          <PageHeader title={'Display Content'} />
        </div>
        <TabsNavigation
          className="display-content-nav mb-6 w-full border-b border-gray-700"
          activeTabIndex={0}
          handleSetActiveTab={function Qa() {}}
        >
          {languages &&
            languages?.length > 0 &&
            languages.map((lang, idx) => (
              <Tab
                key={`${idx}_${lang.code}`}
                label={lang.title}
                className="no-icon"
                onClick={() => handleTabClick(lang.code)}
                isDark
              />
            ))}
        </TabsNavigation>

        <DisplayContentTab
          displayContentFormData={displayContentFormData}
          setDisplayContentFormData={data => setDisplayContentFormData(data)}
          activeLanguage={activeLanguage}
          languages={languages}
          targetType={targetType}
        />
      </PageContent>
      {/* {joinCampaignFlag && ( */}
      <PageContent className="sales-target-component bg-neutral-800 text-white" pageContentWrapperClassName="relative">
        <UploadMedia
          mediaCardFormData={mediaCardFormData}
          setMediaCardFormData={setMediaCardFormData}
          uploadFor={Constants.SalesTarget}
          MediaCardUiSchema={MediaCardUiSchema}
          fileType="image"
        />
        {/* <ImageWithRadioBtn imagesList={getTargetImages()} handleImageSelect={handleImageSelect} /> */}
      {errorMessage ? <span className='error'>You must select one Foreground and one Background image.</span> : null}

      </PageContent>
      {/* )} */}
    </>
  )
}

export default DisplayContent
